var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu-bar-left"},[_c('VueButton',{attrs:{"color":"grey-50","iconName":_vm.btnBackIcon.name,"iconSize":{
        width: _vm.btnBackIcon.width,
        height: _vm.btnBackIcon.height,
      },"iconColor":_vm.backButtonColor,"ghost":true,"target":"-1"},on:{"click":_vm.onBackButtonClick}})],1),_c('div',{staticClass:"menu-bar-right"},[_c('VueText',{staticClass:"back-btn-title",attrs:{"sizeLevel":"8","weightLevel":"4"}},[_vm._v("Ayarlar")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }